import type { FC } from 'react';
import { useCallback } from 'react';
import type { MarketHistoryProps } from './types';
import MarketHistoryWidget from './market-history-widget';
import { MarketDataProvider } from '../../../../providers/market-data/market-data-provider';
import { SnapshotProvider } from '../../../../providers/snapshot-provider';
import { VolMarketProvider } from '../../../../providers/vol-market-provider';
import { OverviewProvider } from '../../../../providers/overview-provider';
import { CurrencyTypeEnum } from '../../../../model/currency_type.enum';
import usePersistentState from '../../../../providers/use-persistent-state';

const MarketHistoryWrapperProvider: FC<MarketHistoryProps> = (props) => {
  const initialToken: CurrencyTypeEnum = props.tokenKey ?? CurrencyTypeEnum.BITCOIN;
  const [currentToken, setCurrentToken] = usePersistentState<CurrencyTypeEnum>(
    ['MARKET_HISTORY_WIDGET', props.providerKey || 'overview'],
    'currentToken',
    initialToken,
  );

  const handleChangeToken = useCallback(
    (t: CurrencyTypeEnum) => {
      setCurrentToken(t);
    },
    [setCurrentToken],
  );

  const providerKey = props.providerKey;
  const providerCompositeKey = providerKey
    ? `${providerKey}-${currentToken}`
    : `default-${currentToken}`;

  return (
    <OverviewProvider providerKey={providerKey}>
      <MarketDataProvider
        key={providerCompositeKey}
        providerKey={providerKey}
        currency={currentToken}
      >
        <SnapshotProvider providerKey={providerKey} tokenKey={currentToken}>
          <VolMarketProvider providerKey={providerKey}>
            <MarketHistoryWidget
              {...props}
              currentToken={currentToken}
              onChangeToken={handleChangeToken}
            />
          </VolMarketProvider>
        </SnapshotProvider>
      </MarketDataProvider>
    </OverviewProvider>
  );
};

export default MarketHistoryWrapperProvider;
